import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL;

// Thunk for fetching payment methods
export const fetchPaymentMethods = createAsyncThunk(
  'expenses/fetchPaymentMethods',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseURL}/PaymentMethods/`,  {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch payment methods');
    }
  }
);

// Thunk for creating new expense
export const createExpense = createAsyncThunk(
  'expenses/createExpense',
  async (expenseData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseURL}/ExpensesSummary/Create/`, expenseData,  {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to create expense');
    }
  }
);

const initialState = {
  paymentMethods: [],
  paymentMethodsStatus: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  createExpenseStatus: 'idle',  // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const expenseManagementSlice = createSlice({
  name: 'expenseManagement',
  initialState,
  reducers: {
    resetCreateStatus: (state) => {
      state.createExpenseStatus = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch payment methods cases
      .addCase(fetchPaymentMethods.pending, (state) => {
        state.paymentMethodsStatus = 'loading';
      })
      .addCase(fetchPaymentMethods.fulfilled, (state, action) => {
        state.paymentMethodsStatus = 'succeeded';
        state.paymentMethods = action.payload;
      })
      .addCase(fetchPaymentMethods.rejected, (state, action) => {
        state.paymentMethodsStatus = 'failed';
        state.error = action.payload;
      })
      // Create expense cases
      .addCase(createExpense.pending, (state) => {
        state.createExpenseStatus = 'loading';
      })
      .addCase(createExpense.fulfilled, (state) => {
        state.createExpenseStatus = 'succeeded';
      })
      .addCase(createExpense.rejected, (state, action) => {
        state.createExpenseStatus = 'failed';
        state.error = action.payload;
      });
  },
});

// Selectors
export const selectPaymentMethods = (state) => state.expenseManagement.paymentMethods;
export const selectPaymentMethodsStatus = (state) => state.expenseManagement.paymentMethodsStatus;
export const selectCreateExpenseStatus = (state) => state.expenseManagement.createExpenseStatus;
export const selectError = (state) => state.expenseManagement.error;

export const { resetCreateStatus } = expenseManagementSlice.actions;
export default expenseManagementSlice.reducer;